export default "__VITE_ASSET__9ilg0rxe__"